// Action types
export const ADD_USER_MESSAGE = 'chatbot/ADD_USER_MESSAGE'
export const ADD_BOT_MESSAGE = 'chatbot/ADD_BOT_MESSAGE'
export const SET_LOADING = 'chatbot/SET_LOADING'
export const CLEAR_CHAT = 'chatbot/CLEAR_CHAT'
export const TOGGLE_CHATBOT = 'chatbot/TOGGLE_CHATBOT'
export const OPEN_CHATBOT = 'chatbot/OPEN_CHATBOT'
export const CLOSE_CHATBOT = 'chatbot/CLOSE_CHATBOT'

/**
 * Auto-incrementing counter to guarantee unique message IDs,
 * even when multiple messages are dispatched within the same millisecond.
 */
let messageCounter = 0

/**
 * Generates a unique message ID by combining timestamp with an incrementing counter.
 * @returns {string} Unique message ID
 */
function generateMessageId() {
  messageCounter += 1
  return `${Date.now()}-${messageCounter}`
}

// Action creators
export const addUserMessage = (text) => ({
  type: ADD_USER_MESSAGE,
  payload: {
    id: generateMessageId(),
    text,
    sender: 'user',
    timestamp: new Date().toISOString(),
  },
})

export const addBotMessage = (text) => ({
  type: ADD_BOT_MESSAGE,
  payload: {
    id: generateMessageId(),
    text,
    sender: 'bot',
    timestamp: new Date().toISOString(),
  },
})

export const setLoading = (isLoading) => ({
  type: SET_LOADING,
  payload: isLoading,
})

export const clearChat = () => ({
  type: CLEAR_CHAT,
})

export const toggleChatbot = () => ({
  type: TOGGLE_CHATBOT,
})

export const openChatbot = () => ({
  type: OPEN_CHATBOT,
})

export const closeChatbot = () => ({
  type: CLOSE_CHATBOT,
})
